class SVGLightboxInstance {
  constructor() {
    this.interactiveSVGContainers = document.querySelectorAll('.lc-interactive-svg-lightbox');
    this.interactiveSVGContainers.forEach(element => this.bindEvents(element));

    document.addEventListener('keydown', (e) => {
      if (e.code === 'Escape') {
        this.closeAllLightboxes();
      }
    })
  }

  bindEvents(interactiveSVGContainer) {
    const svg = interactiveSVGContainer.querySelector('.lc-interactive-svg-lightbox__svg');
    const legendItems = svg.querySelectorAll('[id^="Legende_"]');

    legendItems.forEach(legendItem => {
      legendItem.addEventListener('click', (e) => {
        const groupSelector = legendItem.id.replace('Legende_', '');
        const group = svg.querySelector('#focusareas>g[id*="' + groupSelector + '"]');

        const legendCircle = legendItem.querySelector('circle');
        if (legendItem.classList.contains('disabled')) {
          legendItem.classList.remove('disabled');
          group?.classList.remove('disabled');
          if (legendCircle) {
            legendCircle.style.stroke = '';
            legendCircle.style.fill = legendCircle.getAttribute('data-fill-color');
          }
        } else {
          if (legendCircle) {
            legendCircle.setAttribute('data-fill-color', window.getComputedStyle(legendCircle).getPropertyValue("fill"));
            legendCircle.style.stroke = window.getComputedStyle(legendCircle).getPropertyValue("fill");
            legendCircle.style.fill = 'transparent';
          }
          legendItem.classList.add('disabled');
          group?.classList.add('disabled');
        }
      });
    })

    const interactiveSvgElements = interactiveSVGContainer.querySelectorAll('#focusareas>g[id]>g[id]');

    interactiveSvgElements.forEach(interactiveElement => {
      interactiveElement.addEventListener('click', (e) => {
        const id = interactiveElement.id?.toLowerCase();
        this.closeAllLightboxes();
        if (id) {
          const targetLightbox = document.querySelector(`[data-lightbox-identifier="${id}"]`);
          if (targetLightbox) {
            targetLightbox.classList.add('active');
          }
        }
      });
    })


    const lightboxs = interactiveSVGContainer.querySelectorAll('.lc-interactive-svg-lightbox-item');
    lightboxs.forEach(lightbox => {
      const lightboxIdentifierElement = lightbox.querySelector('.lc-interactive-svg-lightbox-item__identifier');
      const lightboxIdentifier = (lightboxIdentifierElement.innerText)?.trim().replaceAll(' ', '').toLowerCase();
      lightbox.setAttribute('data-lightbox-identifier', lightboxIdentifier);

      const closeButton = lightbox.querySelector('.lc-interactive-svg-lightbox-item__close');
      closeButton.addEventListener('click', (e) => {
        lightbox.classList.remove('active');
      });
    });
  }

  closeAllLightboxes() {
    const activeLightboxes = document.querySelectorAll('.lc-interactive-svg-lightbox-item.active');
    activeLightboxes.forEach(activeLightbox => {
      activeLightbox.classList.remove('active');
    });
  }

}

export default SVGLightboxInstance;
